import React, { ReactElement, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { media, padding } from "./common/styles";
export type RootContainerProps = {
  children: ReactNode;
  inPopoverMode: boolean;
};
export function RootContainer({
  children,
  inPopoverMode
}: RootContainerProps): ReactElement {
  const {
    i18n
  } = useTranslation();
  return <Container inPopoverMode={inPopoverMode} dir={i18n.dir()} data-sentry-element="Container" data-sentry-component="RootContainer" data-sentry-source-file="RootContainer.tsx">
      {children}
    </Container>;
}
function getFixedRootCSS(inPopoverMode: boolean) {
  if (inPopoverMode) {
    return css`
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1040;
    `;
  }
  return null;
}
export default RootContainer;
const Container = styled.div<{
  inPopoverMode: boolean;
}>`
  ${({
  inPopoverMode
}) => getFixedRootCSS(inPopoverMode)}

  width: 100%;
  height: 100%;

  padding-top: ${({
  inPopoverMode
}) => inPopoverMode ? "180px" : "0px"};
  background-color: ${({
  inPopoverMode
}) => inPopoverMode ? "rgba(0,0,0,0.5)" : "none"};

  @media ${media.desktop} {
    ${padding.zero}
  }
`;